import * as Yup from "yup"
import _, { values } from "lodash"
import {
  renderFieldInventoryOnHand,
  renderFieldPackageType,
  renderFieldReorderQuantity,
  renderFieldPackageReceived,
  renderFieldOrderQuantity,
  renderFieldOrderReceived,
  renderFieldUnitPrice,
  renderFieldTotalPrice,
  renderFieldExpiryDate,
  renderFieldBatchNumber,
  renderFieldAdjustmentReason,
  renderFieldAdjustmentType,
  renderFieldProjectedInventory,
  renderFieldInventoryNotes
} from "./renderProps"
import * as Utils from "@utils"

export const doDataInitialValues = (
  editData,
  isStorage = false,
  viewPage = "edit"
) => {
  let commonData = {
    projected_inventory: _.get(editData, "projected_inventory", "") || "",
    inventoryOnHand: _.get(editData, "inventoryOnHand", "") || "",
    _id: _.get(editData, "_id", "") || "",
    notes: _.get(editData, "notes", "") || "",
    barcodeValue: _.get(editData, "barcodeValue", "") || "",
  }

  /**
   * @LOCATION_STORE_DATA
   */
  let storeData = {
    adjustment_type: _.get(editData, "adjustment_type", "") || "",
    adjustment_reason: _.get(editData, "adjustment_reason", "") || "",
    quantity: _.get(editData, "quantity", "") || "",
  }

  const config = {
    ...commonData,
    ...storeData,
  }

  return config
}

export const doValidationSchema = (
  props,
  isStorage = false,
  viewPage = "edit"
) => {
  const { isTax = false } = props

  const countWords = (text) => {
  return text.trim().split(/\s+/).filter(Boolean).length;
  };

  let commonSchema = {
    inventoryOnHand: Yup.string()
      .required("ENTER_AVAILABLE_ON_HAND")
      .trim("WHITE_SPACES_CANNOT_BE_ALLOWED")
      .strict(true)
      .matches(
        Utils.JSUtils.getYupValidationCheck(/^(\d*\.{0,1}\d{0,2}$)/, true),
        `PLEASE_ENTER_VALID_FORMAT`
      ),
    projected_inventory: Yup.string().required("AUTO_PROJECTED_INVENTORY"),
  }

  let storeSchema = {
    // ...taxSchema,
    adjustment_type: Yup.string().required("SELECT_ADJUSTMENT_TYPE"),

    quantity: Yup.string()
      .trim("WHITE_SPACES_CANNOT_BE_ALLOWED")
      .strict(true)
      .required("ENTER_QUANTITY")
      .matches(
        Utils.JSUtils.getYupValidationCheck(/^(\d*\.{0,1}\d{0,2}$)/, true),
        `PLEASE_ENTER_VALID_FORMAT`
      ),
    adjustment_reason: Yup.string().required("SELECT_ADJUSTMENT_REASON"),
    notes: Yup.string().test(
      'wordCount',
      'SUPPORT_NOTES_MUST_NOT_EXCEED_100_WORDS',
      value => {
        const wordCount = countWords(value || '');
        return wordCount <= 100;
      }
    )
    .test(
      'validChars',
      'ONLY_ALPHANUMERIC_AND_SPECIAL_CHARACTERS_ARE_ALLOWED',
      value => {
        const regex = /^[\w\d\s.,~!@#$%^&*()_+\-=\[\]{}|;:'"`,’<>/?\\]*$/;
        return regex.test(value || '');
      }
    ),
  }

  let formSchema = storeSchema

  const config = {
    ...commonSchema,
    ...formSchema,
  }

  return config
}

export const doRenderList = (
  isStorage = false,
  viewPage = "",
  packageList = []
) => {
  let store = [
    renderFieldInventoryOnHand,
    renderFieldAdjustmentType,
    renderFieldReorderQuantity,
    renderFieldAdjustmentReason,
    // renderFieldTaxRate,
    // renderFieldTaxValue,
    renderFieldProjectedInventory,
    renderFieldInventoryNotes,
  ]

  return [...store]
}
